const defaultState = {
    user: null,
    orderDetail: {},
    
};

export default (state = defaultState, action) => {
    let newState = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case 'setOrderDetail':
            newState.orderDetail = action.value;
            break;
        default:
            break;
    }
    return newState;
}